import {Button, Grid, Typography} from "@material-ui/core";
import GenericDialog from "../../../../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {useMemo, useState} from "react";
import PropTypes from "prop-types";
import ButtonWithProgress from "../../../../../../../../../../ui/buttons/button-with-progress/ButtonWithProgress";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../../../../../../../../../../store";
import {E2_01_D_03_10} from "../../../../../../../../../../../shared/texts";
import {simsToIccIdAndMsisdnList} from "../../../../../../../../../../../shared/utils/utils";
import {ConfirmationDialog} from "../../../../../../../../sim/Dialogs/confirmation-dialog/ConfirmationDialog";

const ChangeOptionDialog = (props) => {
    const loadingReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.loading);
    const dispatch = useDispatch()
    const uid = useSelector(state => state.authReducer.userClaims.uid)
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany)
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)

    const handleChangeOptionForSims = () => {
        dispatch(actions.submitReportInSegnalazione(selectedCompany.integrationId, selectedCompany.livelloDiAssistenzaId,
            E2_01_D_03_10, uid, "", "",
            "", "", "",
            simsToIccIdAndMsisdnList(props.selectedSims), "",
            !props.isRemove ? [props.option.slug] : [], props.isRemove ? [props.option.slug] : [],
            () => setOpenConfirmationDialog(true)))
    }

    const handleConfirmationDialogClose = () => {
        setOpenConfirmationDialog(false)
        props.handleDialogClose()
    }

    const confirmationDialogContent = useMemo(() => (
        [`L'operazione richiesta di ${props.isRemove ? "disassociazione" : "aggiunta"} SIM è andata a buon fine.`,
            "Chiudi questa finestra per continuare la navigazione"]
    ), [props.isRemove])

    const dialogContent = (
        <>
            <Typography variant="body2">
                Verranno {props.isRemove ? "disassociate" : "aggiunte"} le seguenti SIM
                dall'opzione {props.option.itemName}
            </Typography>
            <Typography variant="body2" style={{whiteSpace: "pre-wrap"}}>
                {props.selectedSims.map(n => n.numeroDiTelefono).join(",\n")}
            </Typography>
        </>
    )

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button variant="outlined" color="primary" onClick={props.handleDialogClose}>annulla</Button>
            <ButtonWithProgress handleClick={handleChangeOptionForSims}
                                text="conferma"
                                loading={loadingReportProblem}/>
        </Grid>
    )

    return (
        <GenericDialog
            open={props.open}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogClose}
        >
            <Typography variant="subtitle1">
                {props.isRemove ? "Disattiva opzione" : "Aggiunta SIM"}
            </Typography>
            {openConfirmationDialog ?
                <ConfirmationDialog dialogTitle={props.isRemove ? "Disattiva opzione" : "Aggiunta SIM"}
                                    content={confirmationDialogContent}
                                    open={openConfirmationDialog}
                                    handleDialogClose={handleConfirmationDialogClose}/>
                : null}
        </GenericDialog>
    )
}

ChangeOptionDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    isRemove: PropTypes.bool.isRequired,
    option: PropTypes.object.isRequired,
    selectedSims: PropTypes.array.isRequired
}

export default ChangeOptionDialog